import dynamic from 'next/dynamic';
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import Gridcom from "../../src/components/Gridcom";
import FooterCom from "../../src/components/FooterCom";
import FooterDis from "../../src/Description/FooterDis";
import Headcom from "../../src/components/Headcom";
import GameCommonDis from "../../src/Description/GameCommonDis";
import CatDis from "../../src/Description/CatDis";
import CatBtn from "../../src/components/CatBtn";
import Pagination from "../../src/components/PaginationNew.js";
import Pagination2 from "../../src/components/Pagination.js";
import BreadCrumbs from "../../src/components/BreadCrumbs";
import { GameList, gamesByTag, toCard, listPageGames } from "../../src/lib/gameData";
import { Categories } from "../../src/list/PageList";
import { Assets } from "../../src/list/Assets";
import BlackScreen from "../../src/components/BlackScreen";
import CookieCom from "../../src/components/CookieCom";
import Snow_fx from "../../src/fx/Snow_fx";
import CategoryGames  from '../../src/components/CategoryGames.js';
// Schema
import Breadcrumb from "../../src/schema/Breadcrumb";

import Ad_728x90_Bot  from '../../src/ads/Ad_728x90_Bot';


export async function getStaticPaths() {
  return {
    paths: Categories.map((page) => ({
      params: { id: page.name },
    })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  const key = Categories.find((page) => page.name === params.id).key;
  return {
    props: {
      // Every game in this category (paginated in the browser via ?page=)
      games: key == "New games" ? GameList.map(toCard) : listPageGames(key) || gamesByTag(key),
    },
  };
}

export default function CategoriesId({ games }) {
  var keyWord;
  var Page_name;
  const path = useRouter();
  const pathName = path.query.id;
  const [mobile, setMobile] = useState(false);


  function bottomDis(value) {
    var myCom;
    if (value.dis != null) {
      myCom = <CatDis name={value.h2} dis={value.dis} />;
    }

    return myCom;
  }

  function pageName(name) {
    var myArray;
    var i;
    for (i = 0; i < Categories.length; i++) {
      if (name == Categories[i].name) {
        myArray = Categories[i];
        keyWord = Categories[i];
        break;
      }
    }
    return myArray;
  }

  // *************************************************************
// Games for this category are selected at build time in getStaticProps
const getGamesByTag = () => games;

const router = useRouter();
const { page = 1 } = router.query; // Get the current page from the URL query
const [currentPage, setCurrentPage] = useState(1);
const gamesPerPage = 70;

useEffect(() => {
  setCurrentPage(parseInt(page, 10)); // Update current page when URL query changes
}, [page]);


const getPaginatedGames = (page) => {
  const startIndex = (page - 1) * gamesPerPage;
  const endIndex = startIndex + gamesPerPage;
  return getGamesByTag(pageName(pathName).key).slice(startIndex, endIndex);
};
const paginatedGames = getPaginatedGames(currentPage);

const handlePageChange = (newPage) => {
  router.push({
    pathname: router.pathname,
    query: { ...router.query, page: newPage }, // Maintain existing query parameters
  });
};

  // Define URLs for each category
  const viewMoreUrls = {
    'Barbie': '/categories/barbie-dress-up',
    'Dress up': '/dress-up-games',
    'Party': '/party-games',
    'Exclusive': '/exclusive-games',
    'Girl games': '/girl-games'
  };
  
  return (
    <>
      <Headcom
        title={pageName(pathName).title}
        s_dis={pageName(pathName).s_dis}
        path={pageName(pathName).path[1] + pageName(pathName).path[0]}
        thumb={pageName(pathName).thumb}
        logo_16={Assets[0].logo_16}
        logo_32={Assets[0].logo_32}
        logo_192={Assets[0].logo_192}
        logo_270={Assets[0].logo_270}
        logo_512={Assets[0].logo_512}
      />

       <Breadcrumb 
            name1={"Playcutegames"}
            link1={pageName(pathName).path[1]}
            name2={"Categories"}
            link2={pageName(pathName).path[1]+"/all-categories"}
            name3={pageName(pathName).h1}
            link3={pageName(pathName).path[1]+pageName(pathName).path[0]}
            />

      <div className="app_cont_game">
        {/* <Searchcom /> */}
        <BlackScreen />
        <div className="game-root">
          <div className="container">
              <CategoryGames games={getPaginatedGames(currentPage)} category={pageName(pathName).h1} dis={pageName(pathName).page_dis} eager={8} />
            {/* <Logocom /> */}
            {/* <div className="grid-container empty-thumb"> */}
              
              {/* <Ad_300x250_1 id={"home_300x250_1"} /> */}
              {/* <Ad_300x250_2 id={"home_300x250_2"} /> */}
          </div>
        </div>
        <Ad_728x90_Bot />
        
      {getGamesByTag(pageName(pathName).key).length > gamesPerPage && (
        <Pagination
        totalGames={getGamesByTag(pageName(pathName).key).length}
        gamesPerPage={gamesPerPage}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        />

        
      )}

        <CatBtn />
        <BreadCrumbs
        catlink={null}
        gamename={pageName(pathName).h1}  />
        {bottomDis(pageName(pathName))}

       
        <GameCommonDis />

        <CookieCom />
      </div>
      <FooterDis />
      <FooterCom />
      <Snow_fx />
    </>
  );
}
